var map = {
	"./ab_gauge_1.png": 1055,
	"./ab_gauge_2.png": 1056,
	"./ab_gauge_3.png": 1057,
	"./ab_gauge_4.png": 1058,
	"./ab_gauge_5.png": 1059,
	"./ab_gauge_6.png": 1060,
	"./ab_gauge_7.png": 1061,
	"./ab_gauge_8.png": 257,
	"./ab_gauge_bg.png": 258
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/meter ^\.\/ab_gauge_.*\.png$
// module id = 1054
// module chunks = 0